'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import CosmicBackground from '@/components/CosmicBackground';

export default function HomePage() {
  const router = useRouter();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (user) {
      router?.replace('/discovery-feed');
    } else {
      router?.replace('/signup');
    }
  }, [user, loading, router]);

  return (
    <div className="min-h-screen nebula-bg flex items-center justify-center">
      <CosmicBackground />
      <div className="relative z-10 text-center">
        <div className="w-12 h-12 border-2 border-accent border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground text-sm">Aligning the stars…</p>
      </div>
    </div>
  );
}